import { DriversRow } from "../../api/models/DriversRow";
import { store, commonSlice } from "../../store";

export const getDriverById = (driver_id?: number, office_id?: number) => {
    const state = store.getState();
    const drivers = state.common.driverNames;
    if (!drivers) {
        return;
    }
    if (!drivers.drivers) {
        return;
    }

    let foundelement;
    drivers.drivers.forEach((element) => {
        if (element.officeId == office_id && element.driverId == driver_id) {
            foundelement = element;
            return;
        }
    });
    return foundelement;
};

export const getDriverIdsByName = (
    driver_name: string,
    office_id: number
): number[] => {
    const state = store.getState();
    const drivers = state.common.driverNames;

    if (!drivers) {
        return [];
    }
    if (!drivers.drivers) {
        return [];
    }

    const driverMatches: number[] = [];
    drivers.drivers.forEach((element) => {
        if (
            element.driverId !== undefined &&
            element.driverName == driver_name
        ) {
            driverMatches.push(element.driverId);
        }
    });
    return driverMatches;
};

export const getDriversByOfficeId = (
    office_id: number
): DriversRow[] | null => {
    const state = store.getState();
    const drivers = state.common.driverNames;

    if (!drivers) {
        return null;
    }
    if (!drivers.drivers) {
        return null;
    }

    const _d = drivers.drivers.filter((x) => {
        return x.officeId == office_id;
    });

    return _d;
};
